import React, { FC, useState } from 'react';
import EditOrReviewDocument from './EditOrReviewDocument/EditOrReviewDocument';
import TwGlobalDocumentViewer from './TwGlobalDocumentViewer/TwGlobalDocumentViewer';
import LeavePage from './LeavePage/LeavePage';
import { AttachmentBasicProps } from '../../redux/api/orders/orders.model';
import { SearchDocumentAttachment } from '../../redux/api/documentAttachments/documentAttachment.model';
import { useGetDocumentAttachmentByIdQuery } from '../../redux/api/documentAttachments/documentAttachmentApi';

// styles
import './TwPreviewDocument.scss';

interface TwPreviewDocumentProps {
  open: boolean;
  files: SearchDocumentAttachment[] | AttachmentBasicProps[];
  id: string;
  isReview: boolean;
  onClose: (order_id: string | null) => void;
  reloadData?: () => void;
}

const TwPreviewDocument: FC<TwPreviewDocumentProps> = ({
  id,
  files,
  isReview,
  open,
  onClose,
  reloadData
}) => {
  const [selectedFileId, setSelectedFileId] = useState(id);
  const [nextPreviousFileId, setNextPreviousFileId] = useState<string | null>(null);
  const [openExpenseModal, setOpenExpenseModal] = useState(false);
  const [isOpenDriverModal, setIsOpenDriverModal] = useState(false);
  const [isOpenEquipmentModal, setIsOpenEquipmentModal] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  const [isOpenNextWarning, setIsOpenNextWarning] = useState(false);
  const [saveAndClose, setSaveAndClose] = useState(false);
  const [saveAndNextWarning, setSaveAndNextWarning] = useState(false);
  const [formHasChanges, setFormHasChanges] = useState(false);

  const handleClose = (order_id: string | null): void => {
    setFormHasChanges(false);
    if (isOpenNextWarning) {
      setIsOpenNextWarning(false);
      nextPreviousFileId && setSelectedFileId(nextPreviousFileId);
      return;
    }

    setIsOpenWarning(false);
    onClose(order_id);
  };

  const saveAndCloseWarning = (): void => {
    setFormHasChanges(false);
    if (isOpenNextWarning) {
      setSaveAndNextWarning(true);
      setIsOpenNextWarning(false);
      nextPreviousFileId && setSelectedFileId(nextPreviousFileId);
      return;
    }

    setSaveAndClose(true);
    setIsOpenWarning(false);
    reloadData && reloadData();
  };

  const closeWarning = (): void => {
    setFormHasChanges(false);
    if (isOpenNextWarning) {
      setIsOpenNextWarning(false);
      return;
    }

    setIsOpenWarning(false);
  };

  // api
  const { data, isLoading } = useGetDocumentAttachmentByIdQuery({ id: selectedFileId });

  return (
    <>
      <TwGlobalDocumentViewer
        files={files}
        selectedFileId={selectedFileId}
        open={open}
        onClose={onClose}
        formHasChanges={formHasChanges}
        setOpenWarning={setIsOpenWarning}
        setOpenNextWarning={(open, fileId): void => {
          setIsOpenNextWarning(open);
          if (open) setNextPreviousFileId(fileId);
          if (!open) setSelectedFileId(fileId);
        }}
        className="preview-document__viewer"
        sx={
          !openExpenseModal &&
          !isOpenDriverModal &&
          !isOpenEquipmentModal &&
          !isOpenWarning &&
          !isOpenNextWarning
            ? {
                position: 'unset'
              }
            : isOpenDriverModal || isOpenEquipmentModal || isOpenWarning || isOpenNextWarning
            ? {
                position: 'fixed !important'
              }
            : {}
        }
        PaperProps={{
          sx: {
            position: 'absolute',
            width: '68%',
            top: 0,
            right: 0,
            margin: 0,
            height: '100vh',
            maxHeight: '100vh',
            zIndex: '1400'
          }
        }}
      />
      <EditOrReviewDocument
        data={data}
        isLoading={isLoading}
        open={open}
        isReview={isReview}
        onClose={onClose}
        saveAndClose={saveAndClose}
        setSaveAndClose={setSaveAndClose}
        saveAndNextWarning={saveAndNextWarning}
        setSaveAndNextWarning={setSaveAndNextWarning}
        setOpenWarning={setIsOpenWarning}
        setOpenExpenseModal={setOpenExpenseModal}
        setIsOpenDriverModal={setIsOpenDriverModal}
        setIsOpenEquipmentModal={setIsOpenEquipmentModal}
        setFormHasChanges={setFormHasChanges}
        reloadData={reloadData}
      />

      <LeavePage
        isOpenWarning={isOpenWarning || isOpenNextWarning}
        handleClose={(): void => handleClose(null)}
        saveAndCloseWarning={saveAndCloseWarning}
        closeWarning={closeWarning}
        closeLabel={isOpenNextWarning ? 'Continue without saving' : 'Close without saving'}
        saveAndCloseLabel={isOpenNextWarning ? 'Save & continue' : 'Save & close'}
      />
    </>
  );
};

export default TwPreviewDocument;
